import { useMemo } from "react";

import { buildSlotPathByIdLookup, useRootNodeData } from "../state/index.ts";

export const useSlotPathByIdMap = () => {
  const rootNode = useRootNodeData();
  return useMemo(() => buildSlotPathByIdLookup(rootNode), [rootNode]);
};
